<template>
  <div>

      <v-card min-height="200px" elevation="0">
        <v-row class="d-flex justify-space-around" :class="{'flex-column': $vuetify.breakpoint.xsOnly}">
          <v-col 
          v-for="ans in one.answers"
          :key="ans.id"
          class="oneStyle" 
          :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
            <v-card class="pa-2" flat>
              <v-img 
                v-for="pict in ans.pictures"
                :key="pict.id"
                height="150px" 
                :src="pict.pictureUrl" 
                :lazy-src="pict.pictureLazyUrl" cover class="my-1">
              </v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="response" column @change="$emit('save', {response, iso: one.iso})">
                  <v-radio :value="ans.iso"  :label="ans.label"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    response: ''
  }),
  props: {
    cursor: Number,
    nbQuestions: Number,
    offerIso: String,
    one: Object
  },
  computed: {
    ...mapGetters('project', ['getResponse'])
  },
  mounted () {
    this.response = this.getResponse({iso: this.offerIso, question: this.one.iso})
  }
}
</script>

<style scoped>
.oneStyle {
  border-right: 1px solid #c1c1c1;
}
</style>